import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundToThousand',
})
export class RoundToThousandPipe implements PipeTransform {
  transform(value?: number | null): number | undefined {
    if (value === null || value === undefined) return undefined;
    return Math.floor(value / 1000) * 1000;
  }
}
